<div [ngClass]="{'video-container': !hasClass}">
    <kh-video-with-events [videotype]="videoType" [videoId]="videoId" [attemptid]="attemptId" [attemptitemorder]="attemptItemOrder" [autoplay]="autoplay"></kh-video-with-events>
    <div class="videoVoteContainer" *ngIf="!hideRatings">
        {{ 'VIDEO.WAS_THIS_VIDEO_HELPFUL' | translate }}&nbsp;&nbsp;
        <div class="videoVoteButtonsContainer">
            <a class="btn btn-xs" [ngClass]="ratingBtnClasses(10)" (click)="rateVideo(+10)">
                <fa-icon [icon]="['far', 'thumbs-up']"></fa-icon>
                {{ 'VIDEO.YES' | translate }}</a>
            <a class="btn btn-xs" [ngClass]="ratingBtnClasses(-10)" (click)="rateVideo(-10)">
                <fa-icon [icon]="['far', 'thumbs-down']"></fa-icon>
                {{ 'VIDEO.NOPE' | translate }}</a>
        </div>
    </div>
</div>
